import Axios from 'axios';
import {commonParamBuilder} from '../../lib/paramBuilder';
import queryString from 'query-string';
import {CustomError} from '../components/common/rootStore';
import * as cookie from 'js-cookie';

export async function getJson<DATA_TYPE>(url: string, queries?: { [key: string]: any }): Promise<DATA_TYPE> {

  const response = await Axios.get<DATA_TYPE>(url, {
    params: queries,
  });
  if (response.status >= 200 && response.status < 400) {
    return response.data;
  } else {
    throw new CustomError('response error', response);
  }
}

export async function postJson<DATA_TYPE>(url: string, body?: any, queries?: { [key: string]: any }): Promise<DATA_TYPE> {

  const response = await Axios.post<DATA_TYPE>(url, body, {
    params: queries,
  });
  if (response.status >= 200 && response.status < 400) {
    return response.data;
  } else {
    throw new CustomError('response error', response);
  }
}

export async function getJsonWithCommonParams<DATA_TYPE>(url: string, queries?: { [key: string]: any }) {
  console.log('getJsonWithCommonParams query>', queries);
  const commonParams = commonParamBuilder.getParams(queryString.parse(window.location.search));
  return await getJson<DATA_TYPE>(url, Object.assign(commonParams, queries || {}));
}

export async function postJsonWithCommonParams<DATA_TYPE>(url: string, body?: any, queries?: { [key: string]: any }) {
  const commonParams = commonParamBuilder.getParams(queryString.parse(window.location.search));
  return await postJson<DATA_TYPE>(url, {
    _csrf: cookie.get('csrfToken'),
    data: body,
  }, Object.assign(commonParams, queries || {}));
}
